import { render } from "./SensorConnection.vue?vue&type=template&id=c8013b70&scoped=true&ts=true"
import script from "./SensorConnection.vue?vue&type=script&lang=ts"
export * from "./SensorConnection.vue?vue&type=script&lang=ts"

import "./SensorConnection.vue?vue&type=style&index=0&id=c8013b70&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8013b70"]])

export default __exports__